goog.provide('el8.data.init');

// Good practice to include anything you're expecting to populate via el8.data.init
goog.require('el8.data.allergies');
goog.require('el8.data.apptTypes');
goog.require('el8.data.base');
goog.require('el8.data.currUser');
goog.require('el8.data.icd9Codes');
goog.require('el8.data.languages');
goog.require('el8.data.medications');
goog.require('el8.data.nonvisitNoteTypes');
goog.require('el8.data.noteSettings');
goog.require('el8.data.pharmacies');
goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.data.practiceSettings');
goog.require('el8.data.staffGroups');
goog.require('el8.data.visitNoteTypes');

/**
 * This file exists to allow us to send down entity-sets** we know we'll need on page load,
 * instead of requiring a separate request (often synchronous) after page load. See, e.g.,
 * the data dict in page-chart.html, which will be passed into this function.
 *
 * Most sets will be covered by the default case below, which covers the case that the key in
 * the data dict is the same as the name of an entity set we want to load with that data (e.g.,
 * a practiceSettings key containining the data we want to load into el8.data.practiceSettings).
 *
 * **(or pseudo entity-sets like some of the arrays of arrays below)
 */
el8.data.init = function(spec) {
    for (var key in spec) {
        if (spec.hasOwnProperty(key) && spec[key]) {
            switch(key) {
                case 'currPractice':
                    el8.data.currPractice = el8.data.practices.create(spec[key]);
                    break;
                case 'currUser':
                    el8.data.currUser.populate(spec[key]);
                    break;
                case 'referralAuths':
                    el8.data.referralAuths = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'phoneTypes':
                    el8.data.phoneTypes = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'races':
                    el8.data.races = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'ethnicities':
                    el8.data.ethnicities = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'analyticsLabs':
                    el8.data.analyticsLabs = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'apptStatuses':
                    el8.data.apptStatuses = spec[key]; // XSS TODO (array of arrays; currently hard-coded so ok but need to be changed)
                    break;
                case 'familyRelationships':
                    el8.data.familyRelationships = spec[key];
                    break;
                case 'noteSettings':
                    el8.data.noteSettings.populate(spec[key]);
                    break;
                case 'practiceSettings':
                    el8.data.practiceSettings.populate(spec[key]);
                    break;
                default:
                    el8.data[key].create(spec[key]);
            }
        }
    }
};

